import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Link } from '@calendly/ui/components/link'
import { ProTip } from '@calendly/ui/components/pro-tip'

import ErrorMessage from 'components/core/error_message'

import { Container, CounterContainer, Counter } from './styles'

const CounterBlock = ({ counter, maxLength }) => {
  if (counter === null) { return <Container /> }
  const tooLong = counter > maxLength

  return (
    <CounterContainer>
      <Counter notValid={tooLong}>
        <span data-testid="text-length">{counter}</span>
        /
        {maxLength}
      </Counter>
      <ProTip spacingLeft={4}>{I18n.t('publisher.event_types.notifications.invitee_sms_reminder.counter_tooltip')}</ProTip>
    </CounterContainer>
  )
}

const ShortenedUrlHelpLink = ({ children }) => (
  <Link
    href="https://help.calendly.com/hc/en-us/articles/1500000432021-Send-text-messages-with-Workflows#a-note-on-short-urls-0-5"
    target="_blank"
    rel="opener"
  >
    {children}
  </Link>
)

export const BodyDetailsField = ({ counter, maxLength, error }) => {
  const tooLong = counter > maxLength
  return (
    <Container>
      <CounterBlock
        counter={counter}
        maxLength={maxLength}
      />
      {error && (
        <ErrorMessage message={HtmlParser(error, { ShortenedUrlHelpLink })} />
      )}
      {!error && tooLong && (
        <ErrorMessage
          message={I18n.t('publisher.event_types.notifications.invitee_sms_reminder.counter_validation_error')}
        />
      )}
    </Container>
  )
}
